var map = {
	"./auth.store.js": "4f46",
	"./beneficiary.store.js": "cf26",
	"./customer.store.js": "9850",
	"./i18n.store.js": "ea7a",
	"./misc.store.js": "586e",
	"./myinfo.store.js": "3041",
	"./registration.store.js": "d1c7",
	"./transaction.store.js": "4112"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7067";